import { getStoreCNSCInfoById } from 'services/api/store';
import toLowerCase from 'utils/toLowerCase';
import { shopeeLocalSellerHostMap } from 'services/config/region';
import { localeCountryCode } from 'services/chattt';
import { openExternalURL } from 'utils/openExternalURL';
import { lazadaServiceLinkMap } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const goPlatform = async (storeId: string) => {
  const { data } = await getStoreCNSCInfoById(storeId);
  const {
    storeInfo: { externalType: platform, storeType, region },
  } = data;
  if (storeType === 'CROSS') {
    openExternalURL(
      platform === 'SHOPEE' ? 'https://seller.shopee.cn/account/signin' : lazadaServiceLinkMap.cnsc,
    );
    return;
  }
  if (platform === 'SHOPEE') {
    let lcc = 'CN';
    if (localeCountryCode) {
      lcc = localeCountryCode;
    }

    let host = `https://seller.${toLowerCase(region)}.shopee.cn`;
    if (lcc !== 'CN') {
      const r = shopeeLocalSellerHostMap[toLowerCase(region)];
      if (r) {
        host = r;
      }
    }

    openExternalURL(host, '__blank');
  } else {
    const link = lazadaServiceLinkMap[toLowerCase(region)];
    link && openExternalURL(link, '__blank');
  }
};
